import { z } from 'zod';
import { createStoredValue } from '../../../shared/lib/storage.ts';

/**
 * What is needed to continue an upload after a reload: the browser forgets the File, so the host
 * picks it again and we check it is the same one before resuming.
 */
export const ResumeRecord = z.object({
  assetId: z.string(),
  title: z.string(),
  filename: z.string(),
  sizeBytes: z.number().int().nonnegative(),
  lastModified: z.number(),
  endpoint: z.string(),
  metadata: z.record(z.string(), z.string()),
});
export type ResumeRecord = z.infer<typeof ResumeRecord>;

const records = createStoredValue('uploads', z.record(z.string(), ResumeRecord), {});

export const uploadRecords = {
  all: (): Readonly<Record<string, ResumeRecord>> => records.read(),
  get: (assetId: string): ResumeRecord | null => records.read()[assetId] ?? null,
  put(record: ResumeRecord) {
    records.write({ ...records.read(), [record.assetId]: record });
  },
  remove(assetId: string) {
    const { [assetId]: _removed, ...rest } = records.read();
    records.write(rest);
  },
};

export const fileMatches = (record: ResumeRecord, file: File): boolean =>
  record.filename === file.name && record.sizeBytes === file.size;
